export default __webpack_public_path__ + "static/media/body-slim.6b61dfad.png";